/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Log_In_Restore_ContentInputs */

const en_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need to log in or sign up to restore your subscription!`)
};

const ar_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب عليك تسجيل الدخول أو التسجيل لاستعادة اشتراكك!`)
};

const de_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie müssen sich anmelden oder registrieren, um Ihr Abonnement wiederherzustellen!`)
};

const es_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas iniciar sesión o registrarte para restablecer tu suscripción.`)
};

const fr_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous ou inscrivez-vous pour retrouver votre abonnement!`)
};

const it_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi effettuare l'accesso o registrarti per ripristinare il tuo abbonamento!`)
};

const ja_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションを復元するには、ログインまたはサインアップする必要があります。`)
};

const ko_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독을 복원하려면 로그인하거나 가입해야 해요!`)
};

const pt_br_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa iniciar sessão ou se registrar para restaurar sua assinatura!`)
};

const ru_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимо войти или зарегистрироваться, чтобы восстановить подписку!`)
};

const th_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณต้องเข้าสู่ระบบหรือลงทะเบียนเพื่อกู้คืนการสมัครสมาชิกของคุณ!`)
};

const tr_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliğini geri yüklemek için giriş yapman veya kaydolman gerekir!`)
};

const zh_cn_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录或注册后才能恢复购买哦！`)
};

const zh_tw_dialog_log_in_restore_content = /** @type {(inputs: Dialog_Log_In_Restore_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入或註冊後才可以還原訂閱喔！`)
};

/**
* | output |
* | --- |
* | "You need to log in or sign up to restore your subscription!" |
*
* @param {Dialog_Log_In_Restore_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_log_in_restore_content = /** @type {((inputs?: Dialog_Log_In_Restore_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Log_In_Restore_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_log_in_restore_content(inputs)
	if (locale === "ar") return ar_dialog_log_in_restore_content(inputs)
	if (locale === "de") return de_dialog_log_in_restore_content(inputs)
	if (locale === "es") return es_dialog_log_in_restore_content(inputs)
	if (locale === "fr") return fr_dialog_log_in_restore_content(inputs)
	if (locale === "it") return it_dialog_log_in_restore_content(inputs)
	if (locale === "ja") return ja_dialog_log_in_restore_content(inputs)
	if (locale === "ko") return ko_dialog_log_in_restore_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_log_in_restore_content(inputs)
	if (locale === "ru") return ru_dialog_log_in_restore_content(inputs)
	if (locale === "th") return th_dialog_log_in_restore_content(inputs)
	if (locale === "tr") return tr_dialog_log_in_restore_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_log_in_restore_content(inputs)
	return zh_tw_dialog_log_in_restore_content(inputs)
});